(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CONFIG = {
      lines: 4,
      moreLabel: 'Read more',
      lessLabel: 'Read less',
      // Classe du texte de l'avis (1er match utilise).
      selectors: [
        '.review__content',
        '.review-slide__content',
        '.review__text',
        '.review-card__text',
        '.review__body'
      ],
      // Classe du nom de l'auteur (le badge se colle a cote).
      authorSelectors: [
        '.review__author-name',
        '.review__author',
        '.review-slide__author',
        '.review__name',
        '.review-card__author'
      ],
      // Textes reconnus comme "verified".
      // Formes accentuees comprises (« Verifie » etait ignore en francais),
      // plus les libelles des autres langues publiees.
      verifiedText: /^(verified|v[ée]rifi[ée]{1,2}|verificado|verificat[oa]|geverifieerd|verifiziert|zweryfikowan[yao]|verifierad|verificeret|vahvistettu)$/i
    };

    // Pastille checkmark (rond vert marque + coche blanche).
    var CHECK =
      '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">' +
        '<circle cx="8" cy="8" r="8" fill="#3D5A47"/>' +
        '<path d="M4.5 8.2l2.2 2.2 4.3-4.6" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    /* ---- Read more (coupe a N lignes) ---- */
    function collect(root) {
      var sel = CONFIG.selectors.map(function (s) { return '.reviews ' + s; }).join(',');
      return (root || document).querySelectorAll(sel);
    }

    function clampOne(el) {
      if (el.dataset.clampInit) return;
      // Section reglee sur « avis entiers » : pas de troncature ni de bouton.
      var host = el.closest('.reviews');
      if (host && host.dataset.reviewClamp === 'false') return;
      el.dataset.clampInit = '1';
      el.classList.add('js-review-clamp');
      el.style.webkitLineClamp = String(CONFIG.lines);

      requestAnimationFrame(function () {
        if (el.scrollHeight <= el.clientHeight + 2) {
          el.classList.remove('js-review-clamp');
          el.style.webkitLineClamp = '';
          return;
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'review-readmore';
        btn.textContent = CONFIG.moreLabel;
        btn.addEventListener('click', function () {
          var open = el.classList.toggle('is-expanded');
          btn.textContent = open ? CONFIG.lessLabel : CONFIG.moreLabel;
        });
        el.insertAdjacentElement('afterend', btn);
      });
    }

    /* ---- Badge Verified a cote du nom ---- */
    function badgeOne(el) {
      if (el.dataset.vbInit) return;
      el.dataset.vbInit = '1';
      // On conserve le libelle saisi (« Verified », « Verifie », « Verificado »…)
      // au lieu de le remplacer par un texte en dur : c'est lui qui porte la
      // traduction servie par Shopify selon la langue.
      var label = (el.textContent || '').trim();
      el.classList.add('review-verified');
      el.innerHTML = CHECK + '<span></span>';
      el.querySelector('span').textContent = label;

      var card =
        el.closest('li, .splide__slide') ||
        el.closest('[class*="review"]') ||
        el.parentElement;
      if (!card) return;

      var author = null;
      for (var i = 0; i < CONFIG.authorSelectors.length; i++) {
        author = card.querySelector(CONFIG.authorSelectors[i]);
        if (author) break;
      }
      if (author && author !== el && !author.contains(el)) {
        author.insertAdjacentElement('afterend', el);
      }
    }

    function findVerified(root) {
      var out = [];
      (root || document).querySelectorAll('.reviews *').forEach(function (el) {
        if (el.children.length === 0 && CONFIG.verifiedText.test((el.textContent || '').trim())) {
          out.push(el);
        }
      });
      return out;
    }

    function init(root) {
      collect(root).forEach(clampOne);
      findVerified(root).forEach(badgeOne);
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    // Re-init dans l'editeur de theme quand la section est rechargee.
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  /* ---- Resume des avis (calcule depuis le DOM) + Load more ---- */
  (function () {
    var FULL = '<span class="material-symbols-outlined notranslate icon icon--star_rate rating-star rating-star--filled" translate="no">star_rate</span>';
    var HALF = '<span class="material-symbols-outlined notranslate icon icon--star_rate_half rating-star" translate="no">star_rate_half</span>';
    var EMPTY = '<span class="material-symbols-outlined notranslate icon icon--star_rate rating-star rating-star--unfilled" translate="no">star_rate</span>';

    function starsHTML(v) {
      var out = '';
      for (var i = 1; i <= 5; i++) {
        if (v >= i) out += FULL;
        else if (v >= i - 0.5) out += HALF;
        else out += EMPTY;
      }
      return out;
    }

    // Note d'une carte : etoiles pleines (+ 0,5 si demi-etoile).
    function cardRating(box) {
      var full = box.querySelectorAll('.rating-star--filled').length;
      var half = box.querySelectorAll('.rating-star:not(.rating-star--filled):not(.rating-star--unfilled)').length;
      return full + (half ? 0.5 : 0);
    }

    function buildSummary(section) {
      var box = section.querySelector('[data-reviews-summary]');
      if (!box || box.dataset.sumInit) return;

      var ratings = [];
      section.querySelectorAll('.review__rating').forEach(function (r) {
        var v = cardRating(r);
        if (v > 0) ratings.push(v);
      });
      box.dataset.sumInit = '1';

      // Produit sans aucun avis : on masque la note et la repartition, mais on
      // laisse le bouton « Donnez votre avis » — c'est precisement ce dont une
      // fiche neuve a besoin.
      if (!ratings.length) {
        var toggleEmpty = box.querySelector('.reviews__summary-toggle');
        if (toggleEmpty) toggleEmpty.hidden = true;
        var barsEmpty = box.querySelector('[data-summary-bars]');
        if (barsEmpty) barsEmpty.hidden = true;
        box.hidden = false;
        return;
      }

      var total = ratings.reduce(function (a, b) { return a + b; }, 0);
      var avg = Math.round((total / ratings.length) * 10) / 10;
      var counts = [0, 0, 0, 0, 0]; // 5,4,3,2,1 etoiles
      ratings.forEach(function (v) {
        var idx = 5 - Math.round(v);
        counts[Math.min(4, Math.max(0, idx))]++;
      });

      // Total saisi a la main : n'a de sens que s'il reflete des avis reels
      // detenus ailleurs (la page n'en montre qu'une selection).
      var override = parseInt(box.dataset.totalOverride, 10);
      var hasOverride = override > 0;
      var shownTotal = hasOverride ? override : ratings.length;

      var avgOverride = parseFloat(box.dataset.ratingOverride);
      if (avgOverride > 0 && avgOverride <= 5) avg = Math.round(avgOverride * 10) / 10;

      var starsEl = box.querySelector('[data-summary-stars]');
      var avgEl = box.querySelector('[data-summary-avg]');
      var cntEl = box.querySelector('[data-summary-count]');
      if (starsEl) starsEl.innerHTML = starsHTML(avg);
      if (avgEl) avgEl.textContent = avg + '/5';
      if (cntEl) {
        var one = box.dataset.countOne || 'review';
        var other = box.dataset.countOther || 'reviews';
        cntEl.textContent = '(' + shownTotal + ' ' + (shownTotal > 1 ? other : one) + ')';
      }

      var bars = box.querySelector('[data-summary-bars]');
      if (bars) {
        var html = '';
        for (var n = 0; n < 5; n++) {
          var stars = 5 - n;
          var cnt = counts[n];
          var pct = Math.round((cnt / ratings.length) * 100);
          html +=
            '<div class="reviews__bar-row">' +
              '<span class="reviews__bar-label">' + stars +
                '<span class="material-symbols-outlined notranslate icon rating-star rating-star--filled reviews__bar-star" translate="no">star_rate</span>' +
              '</span>' +
              '<span class="reviews__bar"><span class="reviews__bar-fill" style="width:' + pct + '%"></span></span>' +
              '<span class="reviews__bar-count">' + (hasOverride ? pct + '%' : cnt) + '</span>' +
            '</div>';
        }
        bars.innerHTML = html;
      }

      var toggle = box.querySelector('.reviews__summary-toggle');
      if (toggle && !toggle.dataset.tgInit) {
        toggle.dataset.tgInit = '1';
        toggle.addEventListener('click', function () {
          var panel = document.getElementById(toggle.getAttribute('aria-controls'));
          if (!panel) return;
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });

        function close() {
          var panel = document.getElementById(toggle.getAttribute('aria-controls'));
          if (!panel || panel.hidden) return;
          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        }
        document.addEventListener('click', function (e) {
          if (!box.contains(e.target)) close();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') close();
        });
      }

      box.hidden = false;
    }

    function initMore(root) {
      (root || document).querySelectorAll('.reviews__grid').forEach(function (grid) {
        if (grid.dataset.moreInit) return;
        var wrap = grid.parentElement;
        var btn = wrap && wrap.querySelector('[data-reviews-more]');
        if (!btn) return;
        grid.dataset.moreInit = '1';

        var items = Array.prototype.slice.call(grid.children);
        function mobile() { return window.matchMedia('(max-width: 749px)').matches; }
        function step() {
          var v = parseInt(mobile() ? btn.dataset.initialMobile : btn.dataset.initialDesktop, 10);
          return v > 0 ? v : 8;
        }
        var shown = step();
        function render() {
          items.forEach(function (li, i) { li.hidden = i >= shown; });
          btn.hidden = shown >= items.length;
        }
        btn.addEventListener('click', function () { shown += step(); render(); });
        var was = mobile();
        window.addEventListener('resize', function () {
          var now = mobile();
          if (now !== was) { was = now; shown = step(); render(); }
        });
        render();
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.reviews').forEach(buildSummary);
      initMore(root);
    }
    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();


  /* ---- Formulaire d'avis : ouverture, notation, envoi ---- */
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-review-form]').forEach(function (modal) {
        if (modal.dataset.rvfInit) return;
        modal.dataset.rvfInit = '1';

        var section = modal.closest('.reviews') || document;
        var form = modal.querySelector('[data-rvf-form]');
        var errBox = modal.querySelector('[data-rvf-error]');
        var done = modal.querySelector('[data-rvf-done]');
        var ratingInput = modal.querySelector('[data-rvf-rating]');
        var stars = Array.prototype.slice.call(modal.querySelectorAll('.rvf__star'));

        function open() {
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          var f = modal.querySelector('input[name="name"]');
          if (f) f.focus();
        }
        function close() {
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }

        section.querySelectorAll('[data-review-form-open]').forEach(function (b) {
          b.addEventListener('click', open);
        });
        modal.querySelectorAll('[data-rvf-close]').forEach(function (b) {
          b.addEventListener('click', close);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) close();
        });

        function paint(v) {
          stars.forEach(function (s, i) {
            var icon = s.querySelector('[data-rvf-icon]');
            var on = i < v;
            if (icon) {
              icon.classList.toggle('rating-star--filled', on);
              icon.classList.toggle('rating-star--unfilled', !on);
            }
            s.setAttribute('aria-checked', i + 1 === v ? 'true' : 'false');
          });
        }

        var chosen = 0;
        stars.forEach(function (s, i) {
          s.addEventListener('click', function () {
            chosen = parseInt(s.dataset.value, 10);
            ratingInput.value = chosen;
            paint(chosen);
          });
          // Apercu au survol, retour a la valeur choisie en sortant.
          s.addEventListener('mouseenter', function () { paint(i + 1); });
        });
        var starsWrap = modal.querySelector('[data-rvf-stars]');
        if (starsWrap) {
          starsWrap.addEventListener('mouseleave', function () { paint(chosen); });
        }

        var fileInput = modal.querySelector('[data-rvf-file]');
        var fileName = modal.querySelector('[data-rvf-filename]');
        if (fileInput && fileName) {
          fileInput.addEventListener('change', function () {
            var f = fileInput.files && fileInput.files[0];
            fileName.textContent = f ? f.name : (fileInput.dataset.none || '');
          });
        }

        function fail(msg) {
          errBox.textContent = msg;
          errBox.hidden = false;
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          errBox.hidden = true;

          var name = form.querySelector('[name="name"]').value.trim();
          var email = form.querySelector('[name="email"]');
          var rating = parseInt(ratingInput.value, 10);

          if (!rating) return fail(form.dataset.msgRating || 'Please select a rating.');
          if (!name) return fail(form.dataset.msgName || 'Please enter your name.');

          var mailVal = email ? email.value.trim() : '';
          if (!mailVal) return fail(form.dataset.msgEmail || 'Please enter your email.');
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mailVal)) {
            return fail(form.dataset.msgEmailBad || 'Please enter a valid email address.');
          }

          var bodyField = form.querySelector('[name="body"]');
          if (bodyField && !bodyField.value.trim()) {
            return fail(form.dataset.msgBody || 'Please write your review.');
          }

          var btn = form.querySelector('.rvf__submit');
          btn.disabled = true;

          var endpoint = form.dataset.endpoint;
          var req;

          if (endpoint) {
            var fd = new FormData(form);
            fd.append('product_handle', form.dataset.product);
            req = fetch(endpoint, { method: 'POST', body: fd });
          } else {
            // Repli : formulaire de contact natif Shopify (email, sans photo).
            var body = new URLSearchParams();
            body.append('form_type', 'contact');
            body.append('utf8', '\u2713');
            body.append('contact[name]', name);
            // Shopify exige une adresse : on retombe sur celle de la boutique
            // quand la cliente n'en laisse pas.
            var mail = email && email.value.trim();
            body.append('contact[email]', mail || form.dataset.fallbackEmail || '');
            if (!mail) body.append('contact[no_email_provided]', 'true');
            body.append(
              'contact[body]',
              'NEW REVIEW — ' + rating + '/5\n' +
              'Product: ' + (form.dataset.productTitle || form.dataset.product) + '\n' +
              'Name: ' + name + '\n\n' +
              (form.querySelector('[name="body"]').value.trim() || '(no text)')
            );
            req = fetch('/contact', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: body.toString()
            });
          }

          req.then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            form.hidden = true;
            done.hidden = false;
          }).catch(function () {
            btn.disabled = false;
            fail(form.dataset.msgError || 'Something went wrong. Please try again.');
          });
        });
      });
    }
    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  /* ---- Defilement vers la section d'avis (liens #ancre) ----
     La page charge ses images en differe : pendant un defilement fluide vers
     une section basse, la hauteur change et la cible se deplace. On defile
     donc une fois, puis on recale sans animation une fois la page stabilisee. */
  (function () {
    function headerOffset() {
      var h = document.querySelector('.header, .section-header, [id*="header-group"]');
      if (!h) return 0;
      var pos = window.getComputedStyle(h).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return h.getBoundingClientRect().height;
    }

    function targetTop(el) {
      return el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    }

    function goTo(el) {
      window.scrollTo({ top: targetTop(el), behavior: 'smooth' });
      setTimeout(function () {
        var tries = 0;
        var timer = setInterval(function () {
          var want = targetTop(el);
          if (Math.abs(window.pageYOffset - want) > 4) window.scrollTo(0, want);
          if (++tries >= 5) clearInterval(timer);
        }, 200);
      }, 700);
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var i = href.indexOf('#');
      if (i < 0) return;
      var hash = href.slice(i + 1);
      if (!hash) return;
      var el = document.getElementById(hash);
      if (!el || !el.classList.contains('reviews')) return;

      // On vise la DERNIERE section d'avis visible de la page : c'est celle
      // que l'on veut atteindre depuis les etoiles du titre, quelle que soit
      // l'ancre configuree sur chacune des sections.
      var all = Array.prototype.filter.call(
        document.querySelectorAll('.reviews'),
        function (n) { return n.offsetParent !== null && n.offsetHeight > 0; }
      );
      if (all.length) el = all[all.length - 1];

      e.preventDefault();
      goTo(el);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
